export const Alignment = {
  Top: 'top',
  Bottom: 'bottom',
  Center: 'center',
  Left: 'left',
  Right: 'right',
};

export const VerticalAlignment = {
  Top: Alignment.Top,
  Bottom: Alignment.Bottom,
  Center: Alignment.Center,
  Baseline: 'baseline',
};

export const HorizontalAlignment = {
  Left: Alignment.Left,
  Center: Alignment.Center,
  Right: Alignment.Right,
};

export const Position = {
  Top: Alignment.Top,
  Bottom: Alignment.Bottom,
  Left: Alignment.Left,
  Right: Alignment.Right,
};

export const Orientation = {
  Vertical: 'vertical',
  Horizontal: 'horizontal',
};
